import * as React from 'react';
import { sortByDisplayOrder } from '../../helper';

// Search UI Facet `view` that renders a multi-checkbox list ordered by `customOrder`
// (values not listed fall to the end). Shared by the checkbox facet and the multiselect
// dropdown facet so both apply the configured value order from one place.
export default function OrderedCheckboxList({label, options, onSelect, onRemove, customOrder}) {
  const sortedOptions = sortByDisplayOrder(options, customOrder);

  return (
    <fieldset className='sui-facet'>
      <legend className='sui-facet__title'>{label}</legend>
      <div className='sui-multi-checkbox-facet'>
        {sortedOptions.map(option => (
          <label className='sui-multi-checkbox-facet__option-label' key={option?.value}>
            <span className='sui-multi-checkbox-facet__option-input-wrapper'>
              <input
                type='checkbox'
                className='sui-multi-checkbox-facet__checkbox'
                checked={option.selected}
                onChange={() => (option.selected ? onRemove(option.value) : onSelect(option.value))}/>
              <span className='sui-multi-checkbox-facet__input-text'>{option.value}</span>
            </span>
            <span className='sui-multi-checkbox-facet__option-count'>{option.count}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
